<template>
  <thead>
    <slot />
  </thead>
</template>

<script>
export default {
  name: 'dx-thead',
};
</script>

<style scoped lang="scss">
:slotted(tr) {
  background: var(--dx-color--blue-semi-light);
  color: var(--dx-color--white);
  text-align: left;
  font-size: var(--dx-text-size--md);
}
</style>
